import React from 'react';
import { Nullable } from 'global';
import { Stack, Typography } from '@mui/material';
import { SvgIconComponent, EventAvailable, EventBusy, ErrorOutline, Schedule } from '@mui/icons-material';

import { EventDue } from '../types';
import { DueTone, resolveDueView } from './lib';

interface Props {
  due: Nullable<EventDue>;
  allDay: boolean;
}

const TONE_PRESENTATION: Record<DueTone, { color: string; Icon: SvgIconComponent }> = {
  overdue: { color: 'error.main', Icon: ErrorOutline },
  urgent: { color: 'warning.main', Icon: Schedule },
  soon: { color: 'warning.dark', Icon: Schedule },
  upcoming: { color: 'success.main', Icon: EventAvailable },
  none: { color: 'text.disabled', Icon: EventBusy },
};

export const DueCell = ({ due, allDay }: Props) => {
  const { tone, label, dateText } = resolveDueView(due, allDay);
  const { color, Icon } = TONE_PRESENTATION[tone];

  return (
    <Stack gap="0.25rem">
      <Stack direction="row" alignItems="center" gap="0.5rem" sx={{ color }}>
        <Icon fontSize="small" />

        <Typography variant="body2" fontWeight={600} sx={{ color: 'inherit' }}>
          {label}
        </Typography>
      </Stack>

      <Typography variant="caption" color="text.secondary">
        {dateText}
      </Typography>
    </Stack>
  );
};
